import {
    GESTIONNAIRE_TABLE,
    ORG_CHART_FINANCE_TABLE,
    GESTIONNAIRE_SOFTWARE_ID,
    ORG_CHART_FINANCE_SOFTWARE_ID,
    GESTIONNAIRE_FIELD,
    ORG_CHART_FINANCE_FIELD,
    ORG_CHART_FINANCE_NAME_FIELD,
    ORG_CHART_FINANCE_CODE_FIELD,
    GESTIONNAIRE_CODE_FIELD,
} from 'routes/BudgetModule/config/constants';
import {
    ResourceType,
    ResourceNameField,
    ResourceSoftwareIdField,
    BudgetProposalT,
    ResourceCodeField,
} from 'routes/BudgetModule/config/types';
import { BudgetBys, BudgetSections } from 'business/constants';
import { camelize } from 'helpers/syntaxHelper';
import { ResourceEventIdFieldT } from '../components/shared/InscriptionsGrid/InscriptionDetails/types';
import {
    GESTIONNAIRE_ID,
    ORG_CHART_FINANCE_ID,
} from '../components/shared/InscriptionsGrid/InscriptionDetails/constants';
import { isActiveBudgetPhase } from '../shared/phases/helpers';
import { TFunction } from 'i18next';

export const isActiveBudgetProposal = (
    budgetProposal: BudgetProposalT,
): boolean => isActiveBudgetPhase(budgetProposal.phase);

export const getResourceType = (by: BudgetBys): ResourceType =>
    by === BudgetBys.GESTIONNAIRE
        ? GESTIONNAIRE_TABLE
        : ORG_CHART_FINANCE_TABLE;

export function getResourceNameField(
    by: BudgetBys,
): 'orgChartFinance.tree' | 'gestionnaire.name';
export function getResourceNameField(
    by: BudgetBys,
    isOrgChartTree: false,
): 'orgChartFinance.name' | 'gestionnaire.name';
export function getResourceNameField(
    by: BudgetBys,
    isOrgChartTree: boolean = true,
): ResourceNameField {
    if (by === BudgetBys.GESTIONNAIRE) return GESTIONNAIRE_FIELD;
    return isOrgChartTree
        ? ORG_CHART_FINANCE_FIELD
        : ORG_CHART_FINANCE_NAME_FIELD;
}

export const getResourceSoftwareIdField = (
    by: BudgetBys,
): ResourceSoftwareIdField =>
    by === BudgetBys.GESTIONNAIRE
        ? GESTIONNAIRE_SOFTWARE_ID
        : ORG_CHART_FINANCE_SOFTWARE_ID;

export const getResourceCodeField = (by: BudgetBys): ResourceCodeField =>
    by === BudgetBys.GESTIONNAIRE
        ? GESTIONNAIRE_CODE_FIELD
        : ORG_CHART_FINANCE_CODE_FIELD;

// Helper to get resource id field but only for inscription's events
export const getResourceIdEventField = (
    by: BudgetBys,
): ResourceEventIdFieldT =>
    by === BudgetBys.GESTIONNAIRE ? GESTIONNAIRE_ID : ORG_CHART_FINANCE_ID;

export const isByGestionnaire = (value: ResourceNameField): boolean =>
    value === GESTIONNAIRE_FIELD;

// Helper to get ventilation string (either 'Service', 'Gestionnaire' or 'service/gestionnaire') from list of budget proposal
export const getResourceVentilationString = (
    budgetProposals: BudgetProposalT[],
    t: TranslationT,
): string => {
    const resourceTypes = Array.from(
        new Set(budgetProposals.map((bp) => getResourceType(bp.by))),
    );

    return resourceTypes
        .map((resourceType) => t(`budget.${camelize(resourceType)}`))
        .join('/');
};

/**
 * Retrieves the translated label for a given budget proposal section.
 */
export const getBpSectionLabel = (
    section: BudgetSections,
    t: TFunction,
): string => {
    return section === BudgetSections.OPERATING
        ? t('budgetProposal.operating')
        : t('budgetProposal.investment');
};
